import { render, staticRenderFns } from "./IAPQuickSettings.vue?vue&type=template&id=a630e3ae&"
import script from "./IAPQuickSettings.vue?vue&type=script&lang=js&"
export * from "./IAPQuickSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports